export const PROJ_CONN_SUMMARY_LOAD_SAGA = 'PROJ_CONN_SUMMARY_LOAD_SAGA'
export const projectConnectionsSummaryLoad = (accountId, projectId) => ({
  type: PROJ_CONN_SUMMARY_LOAD_SAGA,
  accountId,
  projectId
})

export const PROJ_CONN_SUMMARY_LOADED = 'PROJ_CONN_SUMMARY_LOADED'
export const projectConnectionsSummaryLoaded = projectConnectionsSummary => ({
  type: PROJ_CONN_SUMMARY_LOADED,
  projectConnectionsSummary
})

export const PROJ_CONN_SUMMARY_LOAD_FAILURE = 'PROJ_CONN_SUMMARY_LOAD_FAILURE'
export const projectConnectionsSummaryLoadFailure = error => ({
  type: PROJ_CONN_SUMMARY_LOAD_FAILURE,
  error
})
